<template>
    <div class="w-view-shell">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页:开始学习</el-breadcrumb-item>
            <el-breadcrumb-item>模拟考题</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="maxbox">
            <img src="@/assets/guanjun.png" alt=""/>
            <el-button @click.stop="again">再测一次</el-button>
            <div class="grade">{{info.true_num/info.cnt_course*100}}分</div>
            <div class="congratulation">恭喜你，完成练习！</div>
            <div class="faled">
                <div class="one">
                    <img src="@/assets/pitch.png" alt=""/>
                    <span>{{info.true_num}}题</span>
                </div>
                <div class="two">
                    <img src="@/assets/cuowu.png" alt=""/>
                    <span>{{info.error_num}}题</span>
                </div>
            </div>
        </div>
        <div class="minbox">
            <div class="worn-out">
                <div class="one">答题用时</div>
                <div class="two">{{formTime(info.use_time)}}</div>
            </div>
            <div class="worn-out">
                <div class="one">正确率</div>
                <div class="two">{{info.true_num/info.cnt_course*100}}%</div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        info: {},
        course_type: 1,
        directory_id: 0,
      }
    },
    mounted () {
      this.course_type = this.$route.query.course_type
      this.directory_id = this.$route.query.directory_id
      this.info = JSON.parse(this.$route.query.info)
    },
    methods: {
      formTime(time){
        // d = parseInt(time / (24 * 60 * 60))
        let m = parseInt(time / 60 % 60) < 10 ? '0' + parseInt(time / 60 % 60) : parseInt(time / 60 % 60)
        let s = parseInt(time % 60) < 10 ? '0' + parseInt(time % 60) : parseInt(time % 60)
        let down_tips = m + '分' + s + '秒'
        return down_tips
      },
      again(){
        this.$router.replace('/contact?course_id=' + this.info.course_id+'&course_type='+ this.course_type+ '&directory_id='+ this.directory_id)
      }
    }
  }
</script>

<style lang="less" scoped>
    .el-breadcrumb__item:last-child .el-breadcrumb__inner,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
        font-weight: 400;
        color: #000;
        cursor: text;
    }

    .el-breadcrumb {
        margin-top: 30px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
    }

    .maxbox {
        position: relative;
        width: 1201px;
        height: 580px;
        border: 1px solid #ccc;
        margin: 30px 0;

        .el-button {
            position: absolute;
            right: 35px;
            top: 39px;
            width: 120px;
            height: 42px;
            border: 1px solid #d8261c;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #d8261c;
        }

        img {
            position: absolute;
            left: 50%;
            transform: translate(-50%);
            width: 149px;
            height: 169px;
        }

        .grade {
            text-align: center;
            height: 56px;
            font-size: 72px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #ffa202;
            line-height: 480px;
        }

        .congratulation {
            height: 1px;
            text-align: center;
            height: 30px;
            font-size: 30px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #343434;
            line-height: 550px;
        }

        .faled {
            display: flex;

            div {
                margin-top: 350px;
                text-align: center;
                flex: 1;
            }

            .one {
                margin-left: 70px;
                width: 67px;
                height: 28px;
                font-size: 30px;
                font-family: PingFang SC;
                font-weight: bold;
                color: #000000;
                line-height: 50px;

                img {
                    position: absolute;
                    bottom: 90px;
                    left: 250px;
                    width: 57px;
                    height: 57px;
                }
            }

            .two {
                margin-left: 90px;
                width: 67px;
                height: 28px;
                font-size: 30px;
                font-family: PingFang SC;
                font-weight: bold;
                color: #000000;
                line-height: 50px;

                img {
                    position: absolute;
                    bottom: 90px;
                    left: 870px;
                    width: 57px;
                    height: 57px;
                }
            }
        }
    }

    .minbox {
        display: flex;
        margin: 18px 0;
        width: 1201px;
        height: 220px;
        border: 1px solid #ccc;

        div {
            text-align: center;
            flex: 1;
        }

        .worn-out {
            .one {
                height: 25px;
                font-size: 26px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 180px;
            }

            .two {
                height: 33px;
                font-size: 40px;
                font-family: PingFang SC;
                font-weight: bold;
                color: #333333;
                line-height: 260px;
            }
        }
    }
</style>
